import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AvatarService } from '../../services/avatar.service';

@Component({
  selector: 'app-avatar-company',
  templateUrl: './avatar-company.component.html',
  styleUrls: ['./avatar-company.component.scss'],
  standalone: false,
})
export class AvatarCompanyComponent {
  @Input() name: string = '';
  @Input() area: string = '';
  @Input() subarea: string = '';
  @Input() address: string = '';
  @Input() avatar: string = '';
  @Output() imagebase64 = new EventEmitter<string>();
  preview = '';
  previewURL?: any;
  limit: number = 202175;
  isAvatarTooBig: boolean = false;
  isFileTypeValid: boolean = true;
  currentAvatar?: string = '';

  constructor(private avatarService: AvatarService) {}

  isInfoAvatar() {
    return !!(this.name && this.area && this.address);
  }

  selectFile(event: any) {
    let result = this.avatarService.selectAvatar(
      event,
      this.imagebase64,
      this.currentAvatar!,
    );
    this.isAvatarTooBig = result.tooBig;
    this.isFileTypeValid = result.isFileTypeValid;
    if (!this.isAvatarTooBig && this.isFileTypeValid) {
      this.preview = result.preview;
      this.avatarService.fileToDataURL(result.file!, (url) => {
        this.previewURL = url;
      });
    }
  }
}
